  import React, { useState, useEffect } from "react";
  import { useRecoilState } from "recoil";
  import {
    cartState,
    ticketCartCountState
  } from "../../NambaStore/state/cartState";
  import Header from "../../../Components/Layout/Header/Header";
  import Footer from "../../../Components/Layout/Footer/Footer";
  import { useNavigate } from "react-router-dom";
  import combinedServices from "../../../shared/services/user-service";
  import Swal from "sweetalert2";
  import getLocalData from "../../../shared/localStorage/getData";
  import userConstants from "../../../shared/constants/user-constants";

import Detail from "../../../assets/images/detail-img.jpg";
import Visa from "../../../assets/images/visa.png";
import Paypal from "../../../assets/images/paypal.png";
import "../Products/ProductListing.scss";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";

  const AddToCart = () => {
    const [cart, setCart] = useRecoilState(cartState);
    const [cartitem, setCartitem] = useState(cart);
    const [cartTicketitem, setCartticketitem] = useState([]);
    const [userid, setUserid] = useState();
    const [username, setUsername] = useState();
    const [validateCartStatus, setValidateCartStatus] = useState();
    const [validateCartErrors, setValidateCartStatusErrors] = useState();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [ticketCount, setTicketCount] = useRecoilState(ticketCartCountState);
    const [notMatchingProducts, setNonMatchingProducts] = useState();
    const [isMandatPopup, setisMandatPopup] = useState(false);
    const [freeProducts, setFreeProducts] = useState([]);
  const [freeProductDetails, setFreeProductDetails] = useState({});
  const [freeProductAttributes, setFreeProductAttributes] = useState({});
  const [attributeNames, setAttributeNames] = useState({});

  const secretKey = userConstants.CRYPTOSECRETKEY;
  const location = useLocation();
  const storestatus =location.state?.storeVisiblity?.isAvailable

    useEffect(async () => {
      const loadTickets = () => {
        const encryptedEventData = localStorage.getItem("EventcartData");
        if (encryptedEventData) {
          const decrypted = CryptoJS.AES.decrypt(
            encryptedEventData,
            secretKey
          ).toString(CryptoJS.enc.Utf8);
          const tickets = JSON.parse(decrypted) || [];
          setCartticketitem(tickets);
          setTicketCount(tickets.length); // Initialize ticket count
        }
      };

      if (getLocalData("user_info", "isLogin")) {
        let userData = getLocalData("user_info", "all").userData.login_user_detail
          .data.user;
        setUserid(userData.id);
        setUsername(userData.user_firstname + " " + userData.user_lastname);
      }

      localStorage.setItem("cartItems", JSON.stringify(cart));
      loadTickets();
      const encryptedEventData = localStorage.getItem("EventcartData");
      if (encryptedEventData) {
        const decryptedOrderId = CryptoJS.AES.decrypt(
          encryptedEventData,
          secretKey
        ).toString(CryptoJS.enc.Utf8);
        const parsedDecryptedData = JSON.parse(decryptedOrderId);
        console.log("parsedDecryptedData", parsedDecryptedData);
        setCartticketitem(parsedDecryptedData);
        fetchMandatoryProducts(parsedDecryptedData);
        getFreeProducts(parsedDecryptedData);
      } else {
        console.log("Data not available in local storage");
      }
    }, [cart]);

    useEffect(async () => {
      if (cart.length > 0) {
        await checkAllInventory();
      }
    }, []);

    const fetchMandatoryProducts = async (parsedDecryptedData) => {
      try {
        if (!parsedDecryptedData) {
          console.log("Both cart and event cart are empty. No action taken.");
          return;
        }

        const response = await combinedServices.getMandatoryProducts(parsedDecryptedData[0].store_id);

        if (response.data.status === 200) {
          const cartProductIds = cart.map((product) => product.id);
          const eventProductIds = parsedDecryptedData.map(
            (ticket) => ticket.event_id
          );
          const allProductIds = [...cartProductIds, ...eventProductIds];
          console.log("allProductIds", allProductIds);

          const nonMatchingProducts = response.data.data.filter(
            (product) => !allProductIds.includes(product.product_id)
          );
          console.log("nonMatchingProducts", nonMatchingProducts);

          if (nonMatchingProducts.length > 0) {
            // Create HTML for product list with buttons
            setisMandatPopup(true);
            setNonMatchingProducts(nonMatchingProducts);
            const productListHTML = nonMatchingProducts
              .map(
                (product) => `
                <div style="margin-bottom: 10px;">
                  ${product.product_name}
                  <button 
                    onclick="window.location.href='/productDetail/${product.product_id}/true'"
                    style="margin-left: 10px; padding: 5px 10px; background: #4466ff; color: white; border: none; border-radius: 4px; cursor: pointer;"
                  >
                    Add to Cart
                  </button>
                </div>
              `
              )
              .join("");

            Swal.fire({
              icon: "warning",
              title: "Mandatory Product Missing",
              html: `The following products are mandatory:<br><br>${productListHTML}`,
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              showCloseButton: true
            });
          }
        }
      } catch (error) {
        console.error("Error fetching mandatory products:", error);
      }
    };

const getFreeProducts = async (parsedDecryptedData) => {
  try {
    console.log("parsedDecryptedData", parsedDecryptedData);
    
    const productPromises = parsedDecryptedData.map(async (item) => {
      try {
        const response = await combinedServices.getFreeproducts({
          eventID: item.event_id,
          storeID: item.store_id
        });
        
        if (response.data.status === 200) {
          return {
            ...item,
            freeProducts: response.data.data
          };
        }
        return item;
      } catch (error) {
        console.error(`Error fetching free products for event ${item.event_id}:`, error);
        return item;
      }
    });
    const results = await Promise.all(productPromises);
    const filteredResults = results.filter(item => item.freeProducts);
    setFreeProducts(filteredResults);
    
    // Fetch attribute names
    try {
      const attributeResponse = await combinedServices.getAttribute(1, 1000, "", filteredResults[0]?.store_id);
      if (attributeResponse?.data?.categories) {
        const nameMap = {};
        attributeResponse.data.categories.forEach(category => {
          category.attributes?.forEach(attr => {
            nameMap[attr.attribute_id] = attr.attributes;
          });
        });
        setAttributeNames(nameMap);
      }
    } catch (error) {
      console.error("Error fetching attribute names:", error);
    }
    
    // Fetch detailed product information for each free product
    const productDetails = {};
    const defaultAttributes = {};
    
    for (const eventItem of filteredResults) {
      for (const product of eventItem.freeProducts?.products || []) {
        try {
          const detailResponse = await combinedServices.getProductDetailsforUser(product.product_id);
          if (detailResponse?.data?.data) {
            productDetails[product.product_id] = {
              product: detailResponse.data.data.product,
              inventory: detailResponse.data.data.inventory || []
            };
            
            // Set default attributes based on inventory or product attributes
            const inventory = detailResponse.data.data.inventory || [];
            if (inventory.length > 0) {
              const attributeKeys = Object.keys(inventory[0].attribute);
              const productDefaults = {};
              attributeKeys.forEach(key => {
                const uniqueValues = [...new Set(inventory.map(item => item.attribute[key]))];
                productDefaults[key] = uniqueValues[0];
              });
              defaultAttributes[product.product_id] = productDefaults;
            } else if (detailResponse.data.data.product.attributes) {
              const attrs = detailResponse.data.data.product.attributes;
              const productDefaults = {};
              Object.keys(attrs).forEach(key => {
                productDefaults[key] = attrs[key][0];
              });
              defaultAttributes[product.product_id] = productDefaults;
            }
          }
        } catch (error) {
          console.error(`Error fetching details for product ${product.product_id}:`, error);
        }
      }
    }
    
    setFreeProductDetails(productDetails);
    setFreeProductAttributes(defaultAttributes);
    
    return results;
    
  } catch (error) {
    console.error("Error in getFreeProducts:", error);
    throw error;
  }
};


    const encryptOrderId = (orderId) => {
      return CryptoJS.AES.encrypt(orderId, secretKey).toString();
    };

    const removeFromCart = (productId, itemId) => {
      const updatedCart = cart.filter(
        (item) => !(item.id === productId && item.inv_id === itemId)
      );
      setCart(updatedCart);
      setCartitem(updatedCart);
      setValidateCartStatus();
      setValidateCartStatusErrors();
    };
    const checkAllInventory = async () => {
      try {
        const updatedCart = await Promise.all(
          cart.map(async (item) => {
            // Skip non-inventory items
            if (item.product_type === "non_inventory") {
              return item;
            }
  
            // Check inventory status for this item
            const response = await combinedServices.QuantityCheck({
              inv_id: item.inv_id,
              quantity: item.quantity // Check if we can add one more
            });
  
            return {
              ...item,
              isLastQuantity: response.data.data?.isLastQuantity || false
            };
          })
        );
  
        setCart(updatedCart);
        setCartitem(updatedCart);
        localStorage.setItem("cartItems", JSON.stringify(updatedCart));
      } catch (error) {
        console.error("Error checking inventory:", error);
      }
    };

    const updateQuantity = async (itemId, action, isNonInventory = false) => {
      // For non-inventory products, just update the quantity without API checks
      if (isNonInventory) {
        const updatedCart = cart.map((item) => {
          if (item.inv_id === itemId) {
            let updatedQuantity = item.quantity;

            if (action === "increment") {
              updatedQuantity += 1;
            } else if (action === "decrement" && updatedQuantity > 1) {
              updatedQuantity -= 1;
            }

            return { ...item, quantity: updatedQuantity };
          }
          return item;
        });

        setCart(updatedCart);
        setCartitem(updatedCart);
        localStorage.setItem("cartItems", JSON.stringify(updatedCart));
        return;
      }

      // Original logic for inventory products
      const updatedCart = cart.map((item) => {
        if (item.inv_id === itemId) {
          let updatedQuantity = item.quantity;

          if (action === "increment") {
            updatedQuantity += 1;
          } else if (action === "decrement" && updatedQuantity > 1) {
            updatedQuantity -= 1;
          }

          return { ...item, quantity: updatedQuantity };
        }
        return item;
      });

      const updatedItem = updatedCart.find((item) => item.inv_id === itemId);

      try {
        const quantityCheckResponse = await combinedServices.QuantityCheck({
          inv_id: updatedItem.inv_id,
          quantity: updatedItem.quantity
        });

        console.log(quantityCheckResponse.data.data);
        const isLastQuantity =
          quantityCheckResponse.data.data?.isLastQuantity || false;

        if (quantityCheckResponse.data.status === 200) {
          const finalUpdatedCart = updatedCart.map((item) =>
            item.inv_id === itemId ? { ...item, isLastQuantity } : item
          );

          setCart(finalUpdatedCart);
          setCartitem(finalUpdatedCart);
          setValidateCartStatus();
          setValidateCartStatusErrors();
          localStorage.setItem("cartitems", JSON.stringify(finalUpdatedCart));
        } else {
          console.error("Not enough quantity available");
          const finalUpdatedCart = updatedCart.map((item) =>
            item.inv_id === itemId ? { ...item, isLastQuantity: true } : item
          );

          setCart(finalUpdatedCart);
        }
      } catch (error) {
        console.error("Error checking quantity:", error);
      }
    };

    const goToProductPage = () => {
      navigate("/productListing");
    };

    const handleProductClick = (id) => {
      navigate(`/productDetail/${id}`);
    };

    const validateCart = async () => {
      try {
        setIsLoading(true);
        if (isMandatPopup) {
          const productListHTML = notMatchingProducts
            .map(
              (product) => `
            <div style="margin-bottom: 10px;">
              ${product.product_name}
              <button 
                onclick="window.location.href='/productDetail/${product.product_id}/true'"
                style="margin-left: 10px; padding: 5px 10px; background: #4466ff; color: white; border: none; border-radius: 4px; cursor: pointer;"
              >
                Add to Cart
              </button>
            </div>
          `
            )
            .join("");

          Swal.fire({
            icon: "warning",
            title: "Mandatory Product Missing",
            html: `The following products are mandatory:<br><br>${productListHTML}`,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCloseButton: true
          });
          return;
        }

        const eventIds = cartTicketitem.map((ticket) => ticket.event_id);
        const allSameEventId = eventIds.every((id) => id === eventIds[0]);

        if (!allSameEventId) {
          Swal.fire({
            icon: "warning",
            title: "Ticket Issue",
            text: "Please add tickets for only one event at a time."
          });
          setIsLoading(false);
          return;
        }
        if (eventIds.length > 0 && eventIds[0]) {
          try {
            const eventClassResponse = await combinedServices.getClassByEvent(eventIds[0]);
            const eventClassData = await eventClassResponse.data.eventClasses;
            console.log('Event class data:', eventClassData);
            console.log("Event class data:", cartTicketitem);
            
            // Validate class limits
            const selectedClassIds = cartTicketitem.flatMap(ticket => 
              ticket.selectedClass?.map(cls => cls.id) || []
            );
            console.log('Selected class IDs:', selectedClassIds);
            const classCountMap = selectedClassIds.reduce((acc, classId) => {
              acc[classId] = (acc[classId] || 0) + 1;
              return acc;
            }, {});
            console.log('Class count map:', classCountMap);
            for (const [classId, requestedCount] of Object.entries(classCountMap)) {
              const eventClass = eventClassData.find(ec => ec.class_Class_Name_ID === parseInt(classId));
              
              if (eventClass?.eventClass_isLimitApplied === 1) {
                const maxEntries = eventClass.eventClass_maximum_entries_per_class;
                const currentEntries = parseInt(eventClass.entriesCount);
                const availableSpots = maxEntries - currentEntries;
                
                if (requestedCount > availableSpots) {
                  setIsLoading(false);
                  Swal.fire({
                    icon: "warning",
                    title: "Class Entry Limit Exceeded",
                    text: `Class "${eventClass.class_Class_Name}" has only ${availableSpots} spots available, but you're trying to register ${requestedCount} entries.`
                  });
                  return;
                }
              }
            }
          } catch (error) {
            console.error('Error fetching event class data:', error);
          }
        }

        // Add free products to cart validation
        const freeProductsForCart = [];
        freeProducts.forEach(eventItem => {
          eventItem.freeProducts?.products?.forEach(product => {
            const selectedAttrs = freeProductAttributes[product.product_id] || {};
            const productDetail = freeProductDetails[product.product_id];
            
            let invId = 0;
            // Find matching inventory item based on selected attributes
            if (productDetail?.inventory?.length > 0) {
              const matchingInventory = productDetail.inventory.find(item => {
                return Object.keys(selectedAttrs).every(key => 
                  item.attribute[key] === selectedAttrs[key]
                );
              });
              if (matchingInventory) {
                invId = matchingInventory.inv_id;
              }
            }
            
            const freeItem = {
              id: product.product_id,
              inv_id: invId,
              image: product.images,
              name: product.product_name,
              price: "0.00",
              quantity: 1,
              attributes: selectedAttrs,
              product_type: product.product_type || "non_inventory",
              storeId: eventItem.store_id
            };
            freeProductsForCart.push(freeItem);
            console.log("Free product data:", freeItem);
            console.log("Selected attributes:", selectedAttrs);
          });
        });
        
        const validatedData = await combinedServices.validateCart(cartitem);
        const allValid = validatedData.data.data.every(
          (item) => item.isValid === true
        );

        if (allValid) {
          setValidateCartStatus(validatedData.data.data);

          // Validate free products only if there's an event ID
          if (eventIds[0]) {
            // Remove duplicates based on id and inv_id combination
            const uniqueFreeProducts = freeProductsForCart.filter((product, index, self) => 
              index === self.findIndex(p => p.id === product.id && p.inv_id === product.inv_id)
            );
            
            const validateFreeProductsData = {
              storeID: freeProducts[0]?.store_id,
              eventId: eventIds[0],
              freeProducts: uniqueFreeProducts
            };
            const validatefree = await combinedServices.validateFreeproducts(validateFreeProductsData);
            console.log("Free products validated successfully", validatefree);
            
            if (!validatefree.data.isValid) {
              setIsLoading(false);
              Swal.fire({
                icon: "warning",
                title: "Free Products Missing",
                text: "Some free products are missing or invalid. Please check your selection.",
                showConfirmButton: true,
                confirmButtonText: "OK"
              });
              return;
            }
          }
          const totalAmount = (
            cart.reduce((total, item) => total + item.price * item.quantity, 0) +
            cartTicketitem.reduce(
              (total, user) => total + parseFloat(user.classWiseTotal || 0),
              0
            )
          ).toFixed(2);

          const saveorderData = {
            userId: userid,
            userName: username,
            items: [...cartitem, ...freeProductsForCart],
            ticketdata: cartTicketitem
          };

          try {
            if (cartTicketitem.length > 0) {
              const checkOrderPayload = {
                userId: cartTicketitem[0].user_id,
                eventId: cartTicketitem[0].event_id
              };
              const orderExistsResponse = await combinedServices.checkorderwithuserandeventid(checkOrderPayload);
              
              if (orderExistsResponse.data.orderExists) {
                setIsLoading(false);
                Swal.fire({
                  icon: "warning",
                  title: "Order Already Exists",
                  text: "You have already placed an order for this event."
                });
                return;
              }
              
              if (orderExistsResponse.data.valid?.status) {
                setIsLoading(false);
                Swal.fire({
                  icon: "warning",
                  title: "Order Already Exists",
                  text: orderExistsResponse.data.valid.message
                });
                return;
              }
            }
            
            const createOrder = await combinedServices.createOrderinTable(
              saveorderData
            );
            const order_id = createOrder.data.data[0].order_id;
            const encryptedOrderId = encryptOrderId(order_id);

            localStorage.setItem("temp_orderId", encryptedOrderId);

            const ticketItems = Array.isArray(cartTicketitem)
              ? cartTicketitem.map((ticket) => ({
                  name: ticket.event_name,
                  price: parseFloat(ticket.classWiseTotal || "0").toFixed(2),
                  inv_id: ticket.event_id,
                  quantity: 1,
                  attributes: {
                    Selected_Classes: Array.isArray(ticket.selectedClass)
                      ? ticket.selectedClass.map((cls) => cls.name).join(", ")
                      : "No Classes Selected", // Handle undefined case
                    Pit_Space: ticket.pit_space ? "Yes" : "No",
                    Special_Note: ticket.special_note || "None"
                  },
                  image: ticket.image || "",
                  product_type: "event_ticket"
                }))
              : [];

            // Merge both cart items, free products and ticket items
            const mergedCartItems = [...cartitem, ...freeProductsForCart, ...ticketItems];
            console.log("ticketdata", mergedCartItems, cartTicketitem);
            const orderData = {
              items: mergedCartItems,
              total: totalAmount,
              orderId: order_id
            };

          if (totalAmount === "0.00") {
            const freeorder = await combinedServices.freeOrder({
              order_id: orderData.orderId
            });
            if (freeorder.data.status === 200) {
              setCart([]);
              setCartticketitem([]);
              localStorage.removeItem("cartItems");
              localStorage.removeItem("EventcartData");
              localStorage.removeItem("temp_orderId");
              setTicketCount(0);
              let getorderData = await combinedServices.mailorderDetails({
                // email: userEmailId,
                email: "daves@concentricsinc.com",
                orderId: Number(orderData.orderId)
              });
              console.log("getorderData", getorderData);
              Swal.fire({
                icon: "success",
                title: "Order Placed",
                text: freeorder.data.message,
                showCloseButton: true,
                focusConfirm: false
              }).then(() => {
                // Navigate after user closes the alert
                navigate(`/MyOrders`);
              });

                setIsLoading(false);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Order Issue",
                  text: freeorder.data.message,
                  showCloseButton: true,
                  focusConfirm: false
                });
                setIsLoading(false);
              }
            } else {
              const apiResponse =
                await combinedServices.shoppingCartPaypalpayment(orderData);

              if (apiResponse.data.status === 200) {
                const approvalUrl = apiResponse.data.data.approvalUrl;
                if (approvalUrl) {
                  window.location.href = approvalUrl;
                }
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Order Failed",
                  text: "There was an error creating your order."
                });
              }
            }
          } catch (error) {
            console.error("Error creating order:", error);
            Swal.fire({
              icon: "error",
              title: "Order Failed",
              text: "An unexpected error occurred while processing your order."
            });
          }
        } else {
          const invalidItems = validatedData.data.data.filter(
            (item) => item.isValid === false
          );

          setValidateCartStatusErrors(invalidItems);
          const errorMessages = invalidItems
            .map(
              (item) =>
                `<li><strong>${item.product_name}:</strong> ${item.message}</li> <br>`
            )
            .join("");

          Swal.fire({
            icon: "warning",
            title: "Cart Issue",
            html: `<ul style="list-style-type: none; padding-left: 0;">${errorMessages}</ul>`,
            showCloseButton: true,
            focusConfirm: false
          });
        }
      } catch (error) {
        console.error("Error validating cart:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "There was an error validating the cart."
        });
      } finally {
        setIsLoading(false); // Stop loader once everything is done
      }
    };

    const removeFromTicketCart = (userId, eventName) => {
      const encryptedEventData = localStorage.getItem("EventcartData");
      let updatedCart = [];

      if (encryptedEventData) {
        try {
          const decryptedData = CryptoJS.AES.decrypt(
            encryptedEventData,
            secretKey
          ).toString(CryptoJS.enc.Utf8);
          updatedCart = JSON.parse(decryptedData) || [];
        } catch (error) {
          console.error("Error decrypting localStorage data:", error);
          updatedCart = [];
        }
      }

      // 🔹 Remove entry with matching `user_id` and `event_name`
      updatedCart = updatedCart.filter(
        (item) => !(item.user_id === userId && item.event_name === eventName)
      );
     getFreeProducts(updatedCart);

      if (updatedCart.length > 0) {
        // 🔹 Encrypt and update localStorage only if the array is not empty
        const encryptedUpdatedData = CryptoJS.AES.encrypt(
          JSON.stringify(updatedCart),
          secretKey
        ).toString();
        localStorage.setItem("EventcartData", encryptedUpdatedData);
      } else {
        // 🔹 Remove `EventcartData` from localStorage if the array is empty
        localStorage.removeItem("EventcartData");
      }

      // 🔹 Update state
      setCartticketitem(updatedCart);
      setTicketCount(updatedCart.length); // Update Recoil ticket count
      setValidateCartStatus();
      setValidateCartStatusErrors();
    };

    const handleEnterEvent = (id) => {
      navigate("../eventTicket/" + id);
    };

    return (
      <>
        <div className="mainCon">
          <Header />
          <div className="mainCont">
            <section className="ContactOuter pt-5 pb-5">
              <div className="container">
                <div>
                  <div className="mb-3 productHd">
                    <span>YOUR CART</span>
                  </div>
                  {isLoading && (
                    <div className="loadingOverlay">
                      <div className="loadingSpinner"></div>
                    </div>
                  )}

                  {cart.length || cartTicketitem.length > 0 ? (
                    <div className="d-flex flex-wrap">
                      <div className="col-12 col-lg-7 cartInfo">
                        {cart.map((item) => (
                          <div
                            key={item.id}
                            className="inner p-3 p-sm-4 d-flex flex-wrap"
                          >
                            <div
                              className="img"
                              // onClick={() => handleProductClick(item.id)}
                            >
                              <img
                                src={
                                  item.image ? JSON.parse(item.image)[0] : Detail
                                }
                                alt={item.name}
                              />
                            </div>
                            <div className="det ps-s ps-sm-4 pt-3 pt-sm-0">
                              <div className="name mb-3">{item.name}</div>
                              <div className="price mb-4">
                                ${item.price} USD{" "}
                                {/* <span className="oldPrice d-block mt-1">
                                  ${item.price.toFixed(2)} USD
                                </span> */}
                              </div>
                              {/* Display attributes in a single line */}
                              <div className="attributes mb-4">
                                <div className="attributesList">
                                  {Object.keys(item.attributes).map(
                                    (key, index) => (
                                      <span key={index} className="attributeItem">
                                        <strong>{key}:</strong>{" "}
                                        {item.attributes[key]}
                                        {index <
                                          Object.keys(item.attributes).length -
                                            1 && ", "}
                                      </span>
                                    )
                                  )}
                                </div>
                              </div>

                              <div className="cartActions d-flex align-items-center mb-4">
                                {/* Quantity Control */}
                                <div className="quantityControl d-flex align-items-center">
                                  <button
                                    className="quantityBtn"
                                    onClick={() =>
                                      updateQuantity(
                                        item.inv_id,
                                        "decrement",
                                        item.product_type === "non_inventory"
                                      )
                                    }
                                    disabled={item.quantity === 1} // Disable if quantity is 1 for both types
                                  >
                                    -
                                  </button>
                                  <span className="quantityDisplay mx-2">
                                    {item.quantity}
                                  </span>
                                  <button
                                    className="quantityBtn"
                                    onClick={() =>
                                      updateQuantity(
                                        item.inv_id,
                                        "increment",
                                        item.product_type === "non_inventory"
                                      )
                                    }
                                    disabled={
                                      item.product_type === "non_inventory"
                                        ? false
                                        : item.isLastQuantity
                                    }
                                  >
                                    +
                                  </button>
                                </div>

                                {/* Remove Item */}
                                <a
                                  href="#"
                                  className="removeLink"
                                  onClick={() =>
                                    removeFromCart(item.id, item.inv_id)
                                  }
                                >
                                  Remove
                                </a>
                              </div>
                            </div>
                          </div>
                        ))}
                        {cartTicketitem?.map((user) => (
                          <div
                            key={user.user_id}
                            className="inner p-3 p-sm-4 d-flex flex-wrap"
                          >
                            <div
                              className="img"
                              onClick={() => handleEnterEvent(user.event_id)}
                            >
                              <img
                                src={
                                  user.image &&
                                  user.image.startsWith("https://nambaweb.s3")
                                    ? user.image
                                    : Detail
                                }
                                alt={user.user_name}
                              />
                            </div>
                            <div className="det ps-s ps-sm-4 pt-3 pt-sm-0">
                              <div className="price mb-3">
                                Event Name - {user.event_name}
                              </div>
                              <div className="mb-3">
                                <strong>User Name</strong> - {user.user_name}
                              </div>
                              <div className="price mb-4">
                                ${user.classWiseTotal} USD
                              </div>
                              <div className="mb-4">
                                <strong>Special Note - </strong>{" "}
                                {user.special_note || "N/A"}
                              </div>

                              {/* Display selected classes or transponders */}
                              <div className="attributes mb-4">
                                <div className="attributesList">
                                  <strong>
                                    {user.selectedClass.some(
                                      (classItem) => classItem.transponder_name
                                    )
                                      ? "Event's Transponders"
                                      : "Event's Classes"}
                                  </strong>
                                  &nbsp;-&nbsp;
                                  {user.selectedClass.map((classItem, index) => (
                                    <span key={index} className="attributeItem">
                                      {/* Check for name, transponder_name, or default to "N/A" */}
                                      {classItem.transponder_name ||
                                        classItem.name ||
                                        "N/A"}
                                      {index !== user.selectedClass.length - 1 &&
                                        ", "}
                                    </span>
                                  ))}
                                </div>
                              </div>

                              <div className="cartActions d-flex align-items-center mb-4">
                                <a
                                  href="#"
                                  className="removeLink"
                                  onClick={() =>
                                    removeFromTicketCart(
                                      user.user_id,
                                      user.event_name
                                    )
                                  }
                                >
                                  Remove
                                </a>
                              </div>
                            </div>
                          </div>
                        ))}
                        
                        {/* Free Products Section */}
                        {freeProducts.map((eventItem) => 
                          eventItem.freeProducts?.products?.map((product) => {
                            const productDetail = freeProductDetails[product.product_id];
                            const inventory = productDetail?.inventory || [];
                            const selectedAttrs = freeProductAttributes[product.product_id] || {};
                            
                            // Get available attributes from inventory or product
                            let availableAttributes = {};
                            if (inventory.length > 0) {
                              const attributeKeys = Object.keys(inventory[0].attribute);
                              attributeKeys.forEach(key => {
                                availableAttributes[key] = [...new Set(inventory.map(item => item.attribute[key]))];
                              });
                            } else if (productDetail?.product?.attributes) {
                              availableAttributes = productDetail.product.attributes;
                            }
                            
                            return (
                              <div
                                key={`free-${product.product_id}`}
                                className="inner p-3 p-sm-4 d-flex flex-wrap"
                                style={{ backgroundColor: '#f8f9fa', border: '2px solid #28a745' }}
                              >
                                <div className="img" style={{ cursor: 'pointer' }} onClick={() => handleProductClick(product.product_id)}>
                                  <img
                                    src={product.images ? JSON.parse(product.images)[0] : Detail}
                                    alt={product.product_name}
                                  />
                                </div>
                                <div className="det ps-s ps-sm-4 pt-3 pt-sm-0">
                                  <div className="name mb-3">
                                    {product.product_name}
                                    <span className="badge bg-success ms-2">FREE</span>
                                  </div>
                                  <div className="price mb-4">
                                    <span style={{ textDecoration: 'line-through', color: '#6c757d' }}>
                                      ${product.retail_price}
                                    </span>
                                    <span className="ms-2" style={{ color: '#28a745', fontWeight: 'bold' }}>
                                      FREE
                                    </span>
                                  </div>
                                  
                                  {/* Attribute Selection */}
                                  {Object.keys(availableAttributes).length > 0 && (
                                    <div className="attributes mb-4">
                                      <div className="row">
                                        {Object.entries(availableAttributes).map(([key, values], index) => (
                                          <div key={key} className="col-md-6 mb-3">
                                            <label className="form-label">
                                              <strong>{attributeNames[key] || key}:</strong>
                                            </label>
                                            <select
                                              className="form-select"
                                              value={selectedAttrs[key] || values[0]}
                                              onChange={(e) => {
                                                const updatedAttrs = {
                                                  ...freeProductAttributes,
                                                  [product.product_id]: {
                                                    ...selectedAttrs,
                                                    [key]: e.target.value
                                                  }
                                                };
                                                setFreeProductAttributes(updatedAttrs);
                                              }}
                                            >
                                              {values.map((value) => (
                                                <option key={value} value={value}>
                                                  {value}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                  

                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                      <div className="col-12 col-lg-5 payOption pt-4 pt-lg-0 ps-0 ps-lg-5">
                        {/* Payment section */}
                        <div className="hd mb-3">How you'll pay</div>
                        <div className="mb-4">
                          <label className="d-flex align-items-center mt-2">
                            <span className="radioWrapper">
                              <input
                                type="radio"
                                name="payment"
                                className="radioInpt"
                                checked
                              />
                              <i className="bg"></i>
                            </span>{" "}
                            <img src={Paypal} alt="" className="ms-3" />
                            <img src={Visa} alt="" className="ms-3" />
                          </label>
                        </div>
                        <div>
                          <ul className="payDetail p-0 m-0">
                            <li className="d-flex justify-content-between pb-2">
                              <span>Item(s) total</span>
                              <span>
                                $
                                {cart
                                  .reduce(
                                    (total, item) =>
                                      total + item.price * item.quantity,
                                    0
                                  )
                                  .toFixed(2)}
                              </span>
                            </li>
                            <li className="d-flex justify-content-between pb-2">
                              <span>Tickets(s) total</span>
                              <span>
                                $
                                {cartTicketitem
                                  .reduce(
                                    (total, user) =>
                                      total +
                                      parseFloat(user.classWiseTotal || 0),
                                    0
                                  )
                                  .toFixed(2)}
                              </span>
                            </li>
                            <li className="d-flex justify-content-between pb-3">
                              {/* Optionally, add more details here */}
                            </li>
                            {/* Combine both carts for Subtotal */}
                            <li className="d-flex justify-content-between pb-2 pt-3 bor">
                              <span>Subtotal</span>
                              <span>
                                $
                                {(
                                  cart.reduce(
                                    (total, item) =>
                                      total + item.price * item.quantity,
                                    0
                                  ) +
                                  cartTicketitem.reduce(
                                    (total, user) =>
                                      total +
                                      parseFloat(user.classWiseTotal || 0),
                                    0
                                  )
                                ).toFixed(2)}
                              </span>
                            </li>
                            <li className="d-flex justify-content-between pb-3">
                              <span>Delivery</span>
                              <span>$ 0.00</span>
                            </li>
                            {/* Combine Subtotal with Delivery (if needed) for Total */}
                            <li className="d-flex justify-content-between pb-2 pt-3 bor">
                              <span>
                                Total (
                                {cart.reduce(
                                  (total, item) => total + item.quantity,
                                  0
                                )}{" "}
                                items)
                              </span>
                              <span>
                                $
                                {(
                                  cart.reduce(
                                    (total, item) =>
                                      total + item.price * item.quantity,
                                    0
                                  ) +
                                  cartTicketitem.reduce(
                                    (total, user) =>
                                      total +
                                      parseFloat(user.classWiseTotal || 0),
                                    0
                                  )
                                ).toFixed(2)}
                              </span>
                            </li>
                          </ul>
                          <div className="mt-4">
                            <a onClick={validateCart} className="checkoutBtn">
                              Proceed to Checkout
                            </a>
                          </div>
                          {/* Optional note */}
                          {/* <div className="mt-4 notetext">
        Local taxes included (where applicable)
        <br />* Learn more about additional taxes, duties, and fees that may apply
      </div> */}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="emptyCart">
                      <h2>Your Cart is Empty</h2>
                      <p>
                        Looks like you haven't added anything to your cart yet.
                      </p>
                      {/* <button
                        className="goToProductPageBtn"
                        onClick={goToProductPage}
                      >
                        Go to Product Page
                      </button> */}
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
          <Footer />
        </div>
      </>
    );
  };

  export default AddToCart;
